import React, { useMemo, useState } from 'react'
import LinkConnector_Img from './images/linkConnectorImg.png';

const WPLink_Connector = () => {
    const [phone, setPhone] = useState('');
    const [msg, setMsg] = useState('');
    const [showPreview, setShowPreview] = useState(false);

    const waLink = useMemo(() => {
        const num = (phone || '').replace(/[^\d]/g, '');
        const text = encodeURIComponent(msg || '');
        if (!num) return '';
        return `https://wa.me/${num}${text ? `?text=${text}` : ''}`;
    }, [phone, msg]);

    const handlePreview = () => setShowPreview(true);
    const handleGenerate = () => {
        if (waLink) window.open(waLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <section
            className="position-relative"
            style={{
                overflow: "hidden",
                background: `
          linear-gradient(to bottom, rgba(255,255,255,0) 78%, rgba(255,255,255,1) 100%),
          radial-gradient(900px 600px at 0% 0%, rgba(204, 233, 254, 0.35) 0%, rgba(191,228,255,0) 60%),
          radial-gradient(900px 600px at 100% 0%, rgba(215, 255, 238, 0.28) 0%, rgba(192,252,226,0) 60%),
          linear-gradient(135deg, #f0f5ff 0%, #EFFFF7 100%)
        `,
                marginTop: 90,
                paddingBottom: 90
            }}
        >
            <div
                className="mx-auto position-relative ws-wrap"
                style={{ maxWidth: "74%", marginTop: 40, padding: "0 16px" }}
            >
                {/* Heading */}
                <header style={{ textAlign: "center" }}>
                    <h2
                        style={{
                            fontSize: "2.3rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        How to Create WhatsApp Links for Free in 3 Simple Steps
                    </h2>
                    <p
                        style={{
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.27,
                            marginBottom: "32px"
                        }}
                    >
                        Creating your personalized WhatsApp link is as simple as one-two-three. Here’s how to do it:
                    </p>
                </header>

                {/* IMAGE — now just ABOVE captions (as per reference) */}
                <div className="mockup" style={{ marginTop: 28, marginBottom: 10 }}>
                    <img src={LinkConnector_Img} alt="Steps visual" />
                </div>

                {/* Captions */}
                <div className="steps-captions">
                    <div className="cap">
                        <h4>Provide Your Contact Details</h4>
                        <p>Enter your WhatsApp Business number into the generator.</p>
                    </div>
                    <div className="cap">
                        <h4>Add a Personal Message</h4>
                        <p>Write a unique pre-filled message to personalize the chat.</p>
                    </div>
                    <div className="cap">
                        <h4>Create Custom WhatsApp Chat Link</h4>
                        <p>Hit “Generate my link” to get your unique chat link for free.</p>
                    </div>
                </div>

                {/* Dynamic, attractive form (below captions) */}
                <div className="form-zone">
                    <div className="form-card">
                        <h5 className="fc-title">Enter your WhatsApp number</h5>

                        <div className="input-row">
                            <div className="cc">🇮🇳</div>
                            <input
                                className="input"
                                type="tel"
                                placeholder="Your phone number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                        <small className="note">
                            Tip: Include country code (e.g., 91 for India).
                        </small>

                        <h5 className="fc-title" style={{ marginTop: 18 }}>Add your custom message</h5>
                        <div className="emoji-row">
                            <button
                                className="emoji-chip"
                                type="button"
                                onClick={() => setMsg((m) => `${m}${m && !m.endsWith(' ') ? ' ' : ''}😊`)}
                            >
                                😊 Add emoji
                            </button>
                            <button
                                className="emoji-chip"
                                type="button"
                                onClick={() => setMsg((m) => `${m}${m && !m.endsWith(' ') ? ' ' : ''}🚀`)}
                            >
                                🚀
                            </button>
                            <button
                                className="emoji-chip"
                                type="button"
                                onClick={() => setMsg((m) => `${m}${m && !m.endsWith(' ') ? ' ' : ''}✔️`)}
                            >
                                ✔️
                            </button>
                        </div>

                        <textarea
                            className="textarea"
                            rows={4}
                            placeholder="Add custom message that users will send to you"
                            value={msg}
                            onChange={(e) => setMsg(e.target.value)}
                        />

                        <small className="ex">
                            Example: “Hello, I am interested to know more about your business”.
                        </small>

                        <button className="btn preview" type="button" onClick={handlePreview}>
                            Preview
                        </button>

                        {showPreview && (
                            <div className="preview-card">
                                <div className="pv-row">
                                    <span className="pv-label">Link</span>
                                    <a
                                        href={waLink || '#'}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={`pv-link ${waLink ? '' : 'disabled'}`}
                                        onClick={(e) => { if (!waLink) e.preventDefault(); }}
                                    >
                                        {waLink || 'Enter phone to generate link'}
                                    </a>
                                </div>
                                <div className="pv-row">
                                    <span className="pv-label">Message</span>
                                    <span className="pv-msg">{msg || '—'}</span>
                                </div>
                            </div>
                        )}

                        <div className="or">— or —</div>

                        <button
                            className="btn primary"
                            type="button"
                            onClick={handleGenerate}
                            disabled={!waLink}
                        >
                            Generate my link
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
        .mockup{
          display:flex; 
          align-items:center; 
          justify-content:center;
        }
        .mockup img{
          margin-top: 2rem;
          width:100%; 
          max-width: 840px; 
          height:auto; 
          display:block;
          filter: drop-shadow(0 10px 24px rgba(0,0,0,.06));
        }

        .steps-captions{
          display:grid;
          grid-template-columns: repeat(3,1fr);
          gap: 22px;
          max-width: 980px;
          margin: 20px auto 28px;
          text-align:center;
        }
        .steps-captions .cap h4{
          margin: 6px 0 6px;
          font: 700 1.05rem Inter;
          color: #242121ff;
        }
        .steps-captions .cap p{
          margin:0; 
          color: #413e3eff; 
          font: 300 .95rem Poppins, system-ui;
          line-height:1.25;
        }

        .form-zone{
          display:flex; justify-content:center;
          margin-top: 16px;
        }

        .form-card{
          width: 100%;
          max-width: 520px;
          background:#fff;
          border: 1px solid rgba(16,71,148,.10);
          border-radius: 14px;
          padding: 18px 18px 20px;
          box-shadow: 0 6px 24px rgba(6,35,82,.08);
        }
        .fc-title{
          margin: 0 0 8px 0;
          color:#0A2C54; font: 700 14px Inter, system-ui;
        }
        .input-row{
          display:flex; align-items:center; gap:8px;
          background:#f6f8fb; border:1px solid #dde6f1;
          border-radius: 10px; padding: 10px 12px;
        }
        .cc{ font-size: 18px }
        .input{
          flex:1; border:none; outline:none; background:transparent;
          font: 400 15px Inter, system-ui; color:#12263f;
        }
        .note{
          display:block; margin-top:6px; color:#6f7a87;
          font: 400 12px Inter, system-ui;
        }
        .emoji-row{ display:flex; gap:8px; margin-top:10px; }
        .emoji-chip{
          background:#f0f7ff; color:#0b62c0;
          border:1px solid #cfe1ff;
          border-radius: 999px; padding: 6px 10px; font: 600 12px Inter;
          cursor:pointer;
        }
        .textarea{
          margin-top:8px; width:100%;
          background:#f6f8fb; border:1px solid #dde6f1;
          border-radius: 12px; padding: 12px;
          resize: vertical; outline:none;
          font: 400 15px Inter, system-ui; color:#12263f;
        }
        .ex{
          display:block; margin-top:6px; color:#6f7a87;
          font: 400 12px Inter, system-ui;
        }
        .btn{
          width:100%; border:none; border-radius: 999px;
          padding: 12px 16px; font:600 15px Inter; cursor:pointer;
        }
        .btn.preview{
          margin-top:12px; background:#fff;
          border:1px solid #cfd9e6; color:#0A2C54;
        }
        .or{
          text-align:center; color:#7b8897; margin: 8px 0;
          font: 600 12px Inter, system-ui;
        }
        .btn.primary{
          background:#12b35d; color:#fff;
          box-shadow: 0 6px 0 rgba(9,107,55,.18) inset;
        }
        .btn.primary:disabled{
          background:#bfe9cf; cursor:not-allowed;
        }

        .preview-card{
          margin-top: 12px;
          background:#f6fbff;
          border:1px dashed #cfe1ff;
          border-radius: 10px;
          padding: 10px 12px;
        }
        .pv-row{ display:flex; gap:10px; align-items:flex-start; margin:6px 0; }
        .pv-label{ min-width:60px; font: 700 12px Inter; color:#0A2C54; }
        .pv-link{ color:#0b62c0; text-decoration: underline; word-break: break-all; }
        .pv-link.disabled{ color:#98a7ba; text-decoration: none; pointer-events:none; }
        .pv-msg{ color:#12263f; font: 400 14px Inter; }

        @media (max-width: 1024px){
          .steps-captions{ grid-template-columns: 1fr; }
        }
      `}</style>
        </section>
    );
};

export default WPLink_Connector;
